import { render } from "./SortingWithFiltersPreset.vue?vue&type=template&id=f81f3b66&scoped=true"
import script from "./SortingWithFiltersPreset.vue?vue&type=script&lang=js"
export * from "./SortingWithFiltersPreset.vue?vue&type=script&lang=js"

import "./SortingWithFiltersPreset.vue?vue&type=style&index=0&id=f81f3b66&scoped=true&lang=css"
import "./SortingWithFiltersPreset.vue?vue&type=style&index=1&id=f81f3b66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f81f3b66"]])

export default __exports__